/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Share = class Share {
  constructor(el) {
    this._formSubmitted = this._formSubmitted.bind(this);
    this._share = this._share.bind(this);
    this._select = this._select.bind(this);
    this._track_select_to_copy_event = this._track_select_to_copy_event.bind(this);
    this.el = el;
    this.el.on("submit", this._formSubmitted);
    this.clipboardButton = this.el.find("[data-clipboard-button]");
    this.sharingActionsBox = this.el.find(".share-actions");
    this.clipboardCopyButton = this.el.find("[data-clipboard-copy-button]");
    this.nativeSharingButton = this.el.find("[data-native-sharing-button]");
    this.nativeSharingButton.on("click", this._share);
    this.successNotification = this.el.find("[data-notification='success']");
    this.errorNotification = this.el.find("[data-notification='error']");
    this.shareUrlInput = this.el.find("#share_url_input");
    this.shareUrlInput.on("click", this._select);
    this.shareUrlInput.one("click", this._track_select_to_copy_event);

    this._show_share_actions();

    new Buyapowa.Views.ClipboardButton(this.clipboardButton);

    if (this.clipboardCopyButton.length > 0) {
      new Buyapowa.Views.ClipboardButton(this.clipboardCopyButton, this.successNotification, this.errorNotification, this.shareUrlInput);
    }
  }

  _formSubmitted(e) {
    e.preventDefault();
    return false;
  }

  _show_share_actions() {
    if (!!navigator.share) {
      this.nativeSharingButton.addClass("available");
    }

    return this.sharingActionsBox.addClass("ready");
  }

  _share() {
    if (navigator.share) {
      return navigator.share({
        title: this.nativeSharingButton.data("share-title"),
        text: this.nativeSharingButton.data("share-description"),
        url: this.nativeSharingButton.data("share-url")}).then(() => {
        return window[this.nativeSharingButton.data("track-method")]();
      }).catch(e => {
        if (e.name === "AbortError") {
          return window[this.nativeSharingButton.data("track-method")]();
        }
      });
    }
  }

  _select() {
    return this.shareUrlInput.select();
  }

  _track_select_to_copy_event() {
    return window[this.shareUrlInput.data("track-method")]();
  }
};